module.exports = __webpack_public_path__ + "img/EMS_user_manual_timeline4.aac137fe.png";